import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Font
} from '@react-pdf/renderer';
import { dateFormatter, getCurrentDateTime } from '../../../../../utils';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 9.7
  },
  box: {
    width: '30%',
    border: '0.5px solid black',
    padding: 5,
    marginBottom: 10,
    borderRadius: '5px'
  },
  column: {
    padding: 3
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  table: {
    display: 'table',
    width: '100%',
    marginTop: 10
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableCol: {
    width: '30%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5,
    marginBottom: 10
  },
  tableCell: {
    fontSize: 10
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const IndoorRegisterationLabelPrint = ({ data }) => {
  console.log(data);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  // Create an array with 30 instances of the patient data (repeat the same data for now)
  const patientData = Array(27).fill(data);

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`IPD Registration`}>
          <Page size="A4" style={styles.page}>
            {/* Repeating Data in Boxes */}
            {patientData.map((dataItem, index) => {
              // Every 3 boxes should be placed in a row
              if (index % 3 === 0) {
                return (
                  <>
                    {/* Start a new row every 3 boxes */}
                    <View style={styles.contentContainer} key={index}>
                      {patientData.slice(index, index + 3).map((dataItem, i) => {
                        return (
                          <View style={styles.box} key={i}>
                            <Text
                              content={`Patient Name: ${dataItem.patient.name_suffix} ${dataItem.patient.first_name} ${dataItem.patient.last_name}`}
                              style={styles.textBold}
                            />
                            <Text content={`UHID/IPD No: ${dataItem.uhid || dataItem.ipd_no}`} />
                            <Text content={`Age: ${dataItem.patient.age}`} />
                            <Text
                              content={`Ward/Room: ${dataItem.consultant_detail.room.ward.name} / ${dataItem.consultant_detail.room.room_no}`}
                            />
                            <Text content={`Doctor: ${dataItem.consultant_detail.doctor.name}`} />
                            <Text content={`Sponsor: ${dataItem.patient.sponsor.name}`} />
                          </View>
                        );
                      })}
                    </View>
                  </>
                );
              }
              return null; // Skip rendering individual boxes, we are handling it in groups of 3.
            })}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
